var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass,attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.addToCart}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.lang('Köp', 'Add to cart')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }